import WeeklySchedule from "./weekly-schedule";

export default WeeklySchedule;